import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import ModeOfTravel from '@mui/icons-material/ModeOfTravel';
import AccountTreeOutlined from '@mui/icons-material/AccountTreeOutlined';
import PersonIconOutlined from '@mui/icons-material/PersonOutlined';
import BadgeOutlined from '@mui/icons-material/BadgeOutlined';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';

// import { Outlet } from 'react-router-dom';
function UserSettingDashboard() {
    return (
        <div className="p-2 setLayout">
            <h5 className='title'>User Setting</h5>
            <div className="grid-container mt-2">
                <Link to="/user-setting-dashboard/location" className="text-decoration-none grid-item">
                    <div className="setting-layout  text-center p-5 rounded">
                        <ModeOfTravel className="icon-setting mb-3" />
                        <span>Location</span>
                    </div>
                </Link>

                <Link to="/user-setting-dashboard/department" className="text-decoration-none grid-item">
                    <div className="setting-layout text-center p-5 rounded">
                        <AccountTreeOutlined className="icon-setting mb-3" />
                        <span>Department</span>
                    </div>
                </Link>

                <Link to="/user-setting-dashboard/AddEmployee" className="text-decoration-none grid-item">
                    <div className="setting-layout text-center p-5 rounded">
                        <PersonIconOutlined className="icon-setting mb-3" />
                        <span>Employee Types</span>
                    </div>
                </Link>

                <Link to="/user-setting-dashboard/status" className="text-decoration-none grid-item">
                    <div className="setting-layout text-center p-5 rounded">
                        <BadgeOutlined className="icon-setting mb-3" />
                        <span>Status Type</span>
                    </div>
                </Link>

                <Link to="/user-setting-dashboard/role" className="text-decoration-none grid-item">
                    <div className="setting-layout text-center p-5 rounded">
                        <WorkOutlineIcon className="icon-setting mb-3" />
                        <span>Roles</span>
                    </div>
                </Link>
            </div>
            <Outlet />
        </div>

    );
}

export default UserSettingDashboard;
